// @flow

import type {
  Comment,
  CommentsById,
} from 'hfty-model-comments/types'

import type {
  Crop,
} from 'fc-model-crops/types'

// Libs
import _first from 'lodash/first'
import _values from 'lodash/values'
import _find from 'lodash/find'

// Effect Manager
import { fork, put, select, take } from 'redux-saga/effects'

// Action Types
import {
  ADD_COMMENT,
  DELETE_COMMENTS,
} from '../constants'

// constants
import {
  PROP_FIELD,
  PROP_ID,
  PROP_CROP,
  PROP_YIELD_TARGET,
} from 'hfty-model-comments'

import {
  PROP_CROP_ID,
  crops$,
} from 'fc-model-crops'


import {
  PROP_REMOVAL_CROP_GROWN,
  PROP_REMOVAL_YIELD,
  PROP_REMOVAL_CROP,
  PROP_RECOMMENDATION_TYPE,
  AG_PHD_MAINTENANCE,
} from 'hfty-model-recommendations'

// Selectors
import {
  // utils
  convertCommentsToFrontendUnits,
  // selectors
  comments$,
} from 'hfty-comments'
import { currentUserUnits$ } from 'hfty-users'
import datatable from '../datatable'

// Operator
import commentsOperator from 'hfty-operator-comments'

// Exports
export default function *watchCommentsOperations (): Generator<*, void, *> {
  while (true) {
    const { type, payload } = yield take([ADD_COMMENT, DELETE_COMMENTS])

    if (type === ADD_COMMENT) {
      yield fork(handleAddComment, payload)
    } else if (type === DELETE_COMMENTS) {
      yield fork(handleDeleteComments)
    }
  }
}

export function *handleAddComment (payload: Object): Generator<*, void, *> {
  const crops: Array<Crop> = yield select(crops$)
  const aCrop = _first(_values(crops))
  const operation = commentsOperator.create({
    model: {
      [PROP_FIELD]: payload[PROP_FIELD],
      [PROP_CROP]: aCrop ? aCrop[PROP_CROP_ID] : null,
      [PROP_YIELD_TARGET]: null,
      [PROP_REMOVAL_CROP_GROWN]: false,
      [PROP_REMOVAL_YIELD]: null,
      [PROP_RECOMMENDATION_TYPE]: AG_PHD_MAINTENANCE.value,
      [PROP_REMOVAL_CROP]: null,
    },
  })

  yield put(commentsOperator.actionCreators.add(operation))
}

export function *handleDeleteComments (): Generator<*, void, *> {
  const comments: CommentsById = yield select(comments$)
  const selectedIds: Array<number> = yield select(datatable.selectors.selectedRecordIds$)
  const currentUserUnits = yield select(currentUserUnits$)
  const crops = yield select(crops$)

  const operations = selectedIds.map(function (commentId: number): * {
    const comment: Comment = _find(comments, (comment: Comment): boolean => comment[PROP_ID] === commentId)
    const convertedComment = convertCommentsToFrontendUnits(comment, crops, currentUserUnits)
    return commentsOperator.create({
      model: convertedComment,
    })
  })
  yield put(commentsOperator.actionCreators.delete(...operations))
}
